import { useParams } from 'react-router';
import { LinkUnavailablePage } from './LinkUnavailablePage';
import { RedirectToServiceRequest } from './RedirectToServiceRequest';

export function OldEstimateRedirect() {
  const { token } = useParams<{ token: string }>();
  if (!token) {
    return <LinkUnavailablePage />;
  }
  return <RedirectToServiceRequest kind="estimate" token={token} />;
}
